import { css } from '@emotion/react';
const ACTION = css({
    fontSize: '1.2rem',
    fontWeight: 600,
    lineHeight: 1.75,
    letterSpacing: '1px'
});
const LINK = css({
    cursor: 'pointer',
    transition: 'opacity 0.2s ease'
});
const REQUIRED = css({
    margin: '0 0 7px',
    display: 'inline-flex',
    alignItems: 'center',
    '&::after': {
        content: "''",
        backgroundColor: '#e53b3b',
        fontSize: '1.6rem',
        marginLeft: 5,
        width: 4,
        height: 4,
        borderRadius: '100%'
    }
});
const STATUS = css({
    display: 'inline-flex',
    alignItems: 'center'
});
const STATUS_BULLET = css({
    content: "''",
    display: 'block',
    borderRadius: '50%',
    marginLeft: 6,
    width: 5,
    height: 5
});
const common = (theme) => css({
    '.pathwayLink': {
        ...ACTION,
        color: theme.primaryAccentColor,
        textTransform: 'uppercase',
        marginLeft: 10
    },
    '.link': {
        ...LINK,
        color: theme.primaryAccentColor
    },
    '.linkWithArrow': {
        ...LINK,
        color: theme.primaryAccentColor,
        '&:hover': {
            opacity: 0.75
        },
        '&::after': {
            content: "'→'",
            marginLeft: 3
        }
    },
    '.error': {
        color: theme.errorColor
    },
    '.spriteIcon': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%'
    },
    '.hiddenBottomShadow': {
        position: 'relative',
        '&::before': {
            content: "''",
            borderTop: '1px solid #dbdbdb',
            width: '100%',
            background: '#fff',
            position: 'absolute',
            top: 0,
            display: 'block'
        }
    },
    '.button': {
        border: 'none',
        background: 'none'
    },
    '.__floater__arrow svg polygon': {
        fill: '#2f3d46'
    },
    '.commonInput': {
        position: 'relative',
        width: '100%',
        '& input, & textarea': {
            width: '100%',
            appearance: 'none',
            color: theme.primaryDataColor,
            font: 'inherit',
            '&::placeholder': {
                fontSize: '1.4rem',
                fontWeight: 400,
                letterSpacing: 'normal',
                textTransform: 'none',
                color: theme.secondaryDataColor
            },
            '&[type="email"]': {
                '&::placeholder': {
                    textTransform: 'none'
                }
            },
            '&:hover': {
                boxShadow: `0 2px 5px 0 ${theme.primaryAccentColor}`
            },
            '&:read-only, &:disabled': {
                opacity: 0.5,
                pointerEvents: 'none',
                '&:hover': {
                    boxShadow: 'none'
                },
                '&:focus': {
                    borderColor: 'transparent',
                    boxShadow: 'none'
                }
            },
            '&:read-only': {
                opacity: 1,
                background: `rgb(213 221 223 / 0.3)`,
                boxShadow: 'none'
            },
            '&:focus': {
                outline: 'none'
            }
        }
    },
    '.commonRequiredMark': REQUIRED,
    '.commonInputContainer': {
        position: 'relative'
    },
    '.commonInputErrorIconContainer': {
        width: 14,
        height: 14,
        position: 'absolute',
        top: 'calc(50% - 7px)',
        right: 8
    },
    '.fileInput': {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        opacity: 0,
        width: '100%',
        cursor: 'pointer',
        '&::-webkit-file-upload-button': {
            cursor: 'pointer'
        }
    },
    '.draftStatus': {
        ...STATUS,
        '&::after': {
            ...STATUS_BULLET,
            background: '#e3e5e6'
        }
    },
    '.liveStatus': {
        ...STATUS,
        '&::after': {
            ...STATUS_BULLET,
            background: '#30a8f2'
        }
    },
    '.pendingStatus': {
        ...STATUS,
        '&::after': {
            ...STATUS_BULLET,
            background: '#fa9256'
        }
    },
    '.rejectedStatus': {
        ...STATUS,
        '&::after': {
            ...STATUS_BULLET,
            background: '#e53b3b'
        }
    },
    '.closedStatus': {
        ...STATUS,
        '&::after': {
            ...STATUS_BULLET,
            background: '#e3e5e6'
        }
    },
    '.commonScroll': {
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#dee0e1',
            borderLeft: '3px solid #fff',
            borderRight: '3px solid #fff',
            borderRadius: 5.5
        },
        '&::-webkit-scrollbar': {
            width: 9
        },
        '&::-webkit-scrollbar-track': {
            boxSizing: 'content-box',
            border: '2px solid #fff',
            backgroundColor: '#fff',
            height: '100%'
        }
    },
    '.focusableElement': {
        '&:focus': {
            outline: 'none'
        },
        '&:focus-visible': {
            outline: '-webkit-focus-ring-color auto 1px'
        }
    },
    '.pdfBody': {
        '& img': {
            width: 'initial !important',
            maxWidth: 'initial !important'
        },
        '& .pdf-container': {
            minWidth: 1350
        },
        '& footer': {
            padding: 0,
            borderTop: 'none'
        }
    }
});
export default common;
//# sourceMappingURL=common.js.map